import api from '.'

export const files = {
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/files`, data, success, fail)
  },
  createBatch (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/files/batch`, data, success, fail)
  },
  copyToSite (id, data, success, fail) {
    api.authenticatedRequest('POST', `/files/${id}/copy`, data, success, fail)
  },
  getForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/files`, null, success, fail)
  },
  get (id, success, fail) {
    api.authenticatedRequest('GET', `/files/${id}`, null, success, fail)
  },
  getPreview (id, success, fail) {
    api.authenticatedRequest('GET', `/files/${id}/preview`, null, success, fail)
  },
  update (id, data, success, fail) {
    api.authenticatedRequest('PUT', `/files/${id}`, data, success, fail)
  },
  delete (id, success, fail) {
    api.authenticatedRequest('DELETE', `/files/${id}`, null, success, fail)
  },
  createVersion (id, data, success, fail) {
    api.authenticatedRequest('POST', `/files/${id}/versions`, data, success, fail)
  },
  listVersionsForFile (id, success, fail) {
    api.authenticatedRequest('GET', `/files/${id}/versions`, null, success, fail)
  },
  createApproval (id, data, success, fail) {
    api.authenticatedRequest('POST', `/files/${id}/approvals`, data, success, fail)
  },
  listApprovalsForFile (id, success, fail) {
    api.authenticatedRequest('GET', `/files/${id}/approvals`, null, success, fail)
  },
  deleteApproval (fileId, approvalId, success, fail) {
    api.authenticatedRequest('DELETE', `/files/${fileId}/approvals/${approvalId}`, null, success, fail)
  },
  getApproverApproval (fileId, approvalId, token, success, fail) {
    api.authenticatedRequest('GET', `/files/${fileId}/approvals/${approvalId}/approval?token=${token}`, null, success, fail)
  },
  getApproverPreview (fileId, approvalId, token, success, fail) {
    api.authenticatedRequest('GET', `/files/${fileId}/approvals/${approvalId}/preview?token=${token}`, null, success, fail)
  },
  updateApproverApproval (fileId, approvalId, data, token, success, fail) {
    api.authenticatedRequest('PUT', `/files/${fileId}/approvals/${approvalId}/approval?token=${token}`, data, success, fail)
  },
  createReport (trialId, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/files/reports`, null, success, fail)
  }
}
